import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';

const useChaptersListStyles = makeStyles({
  paragraph: {
    fontFamily: mixins.fontFamilyTT,
    fontWeight: mixins.fontWeight400,
    fontStyle: 'normal',
    fontSize: 18,
    lineHeight: '24px',
    letterSpacing: '0.24px'
  },
  optionItem: {
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `1px solid ${mixins.tableBorderBottom}`,
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  formControlLabel: {
    flex: 1,
    margin: 0,
    padding: 0,
    alignItems: 'center',
    '& .MuiFormControlLabel-label': {
      fontFamily: mixins.fontFamilyPlusSans,
      fontWeight: mixins.fontWeight500,
      fontStyle: 'normal',
      fontSize: mixins.fontSize16,
      lineHeight: '24px',
      letterSpacing: '0.24px'
    }
  },
  textField: {
    backgroundColor: '#FFFFFF',
    '&.MuiOutlinedInput-root': {
      fontSize: 14,
      padding: 0, // remove internal padding
      height: 36 // control outer height
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px !important', // control input padding
      height: '100%', // ensure it fills the height
      boxSizing: 'border-box'
    }
  },
  input: {
    padding: '10px !important'
  },
  //
  customCheckbox: {
    padding: 0,
    border: 0,
    marginRight: 4,
    color: mixins.amethyst,
    '&.Mui-checked': {
      color: mixins.amethyst
    },
    '& svg': {
      fontSize: 18
    },
    '&.Mui-disabled': {
      '& $checkboxIcon': {
        fill: mixins.bulkEditCtaButtonDisabledBGColor,

        '& rect': {
          fill: mixins.bulkEditCtaButtonDisabledBGColor
        }
      }
    }
  },
  checkboxIcon: {},
  tooltipPlacementTop: {
    '& .MuiTooltip-arrow': {
      left: '16px !important'
    }
  },
  questionCount: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight500,
    fontSize: 14,
    lineHeight: '22px',
    color: mixins.greyScaleColor,
    marginLeft: 'auto',
    minWidth: 80
  },
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flex: '1 1 0',
    alignSelf: 'stretch',
    flexDirection: 'column',
    borderRadius: 8,
    border: '1px solid #DBD9E5',
    height: 280,
    background: '#FEFEFE',
    paddingBottom: '16px',
    boxSizing: 'border-box'
  },
  checkboxContainerError: {
    border: `2px solid ${mixins.accentRedDark} !important`
  },
  tocListContainer: {
    gap: 8,
    minHeight: 140,
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  chapterRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    boxSizing: 'border-box',
    position: 'relative'
  },
  expandButton: {
    marginRight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: '50%',
    border: 'none',
    padding: 12,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    },
    '& svg': {
      fontSize: 8,
      width: 8,
      height: 8
    }
  },
  modulesContainer: {
    paddingLeft: 0,
    padding: 0
  },
  // Module row styling
  moduleRow: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minHeight: 24,
    width: '100%',
    gap: 4,
    position: 'relative',
    '&:last-child': {
      borderBottom: 'none'
    },
    '& .contentWrapper': {
      padding: '4px 8px'
    }
  },
  moduleCheckbox: {
    padding: 4,
    color: mixins.amethyst,
    '&.Mui-checked': {
      color: mixins.amethyst
    },
    '& .MuiSvgIcon-root': {
      fontSize: 20
    }
  },
  // Common indentation for all levels
  commonIndent: {
  },
  // Text label styles for vertical layout
  textLabel: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight500,
    fontStyle: 'normal',
    fontSize: mixins.fontSize16,
    lineHeight: '24px',
    color: mixins.color_text_primary,
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 1,
    maxWidth: 506
  },
  moduleTextLabel: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight400,
    fontStyle: 'normal',
    fontSize: 16,
    lineHeight: '20px',
    letterSpacing: '0.2px',
    color: '#555',
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 1,
    maxWidth: 506
  },
  modalTextLabel: {
    maxWidth: '480px !important'
  },
  expandButtonSpacer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  disabledText: {
    color: mixins.bulkEditCtaButtonDisabledColor
  },
  // Ensure perfect vertical alignment for all elements
  moduleFormControlLabel: {
    flex: 1,
    margin: 0,
    padding: 0,
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    '& .MuiFormControlLabel-label': {
      fontFamily: mixins.fontFamilyTT,
      fontWeight: mixins.fontWeight400,
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: '20px',
      letterSpacing: '0.2px',
      color: '#555',
      marginLeft: 8,
      display: 'flex',
      alignItems: 'center',
      height: '100%'
    }
  },
  contentWrapper: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    maxHeight: 40,
    gap: 8,
    padding: '12px 8px',
    minHeight: 48,
    boxSizing: 'border-box'
  },
  moduleContentWrapper: {
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    boxSizing: 'border-box'
  },
  expandedWrapper: {
    padding: '8px 0px 8px 32px',
    width: '100%',
    boxSizing: 'border-box'
  },
  checkboxWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  }
});

export default useChaptersListStyles;
